import { Link } from "react-router-dom";
import "./css/Card.css";
import Icono from "../Icono";

/* La tarjeta con icono del hub.
 *
 * Recibe el NOMBRE del icono (ver `Icono.jsx`) y no una ruta a un PNG. Antes
 * el default era `LogoDefault`, una variable que este archivo NUNCA importó:
 * una tarjeta sin `logo` explotaba en tiempo de ejecución con
 * "LogoDefault is not defined" y nadie se enteraba hasta abrir esa pantalla.
 * Ahora sin icono simplemente no se dibuja ninguno.
 */
const Card = ({ title, icono = null, route = null, onClick = null }) => {
  const cuerpo = (
    <div className="card2">
      <div className="card-section-line">
        {icono && <Icono nombre={icono} tam={26} className="card-logo" />}
        <h3 className="card-title2">{title}</h3>
      </div>
    </div>
  );

  return route ? (
    <Link to={route} className="card-route">
      {cuerpo}
    </Link>
  ) : (
    <div onClick={onClick}>{cuerpo}</div>
  );
};

export default Card;
